module.exports = __webpack_public_path__ + "static/img/ag_2.e34a3a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_2.png
// module id = 869
// module chunks = 1